<template>
  <!-- 暂时不用 -->
  <a-form ref='ruleForm' :rules="rules" :model='form' :labelCol="{span:5}" :wrapper-col="{span:19}">
     当前活动中,指定一下第N个，码或每N个码被领奖时发放指定奖品：<a-tooltip placement='right'>
        <template #title>1、可设置指定第N个码中奖或每N个码中奖。
2、设置指定第N个码中奖后，可指定当前活动的第几个码被领奖时根据设置的概率获得指定的奖项。
3、设置指定每N个码中奖后，可指定当前活动每扫几个码就会根据设置的概率发放指定的奖项。
        </template>
        <InfoCircleOutlined />
      </a-tooltip>
    <a-form-item label="指定N码中奖" name='rule_mark_num' required>
      <p v-for="(v,index) in form.num_arr" :key="v">
        第 <a-input-number style="width:200px" v-model:value="v.number" placeholder="(限1-1000的整数)" :precision="0" :min="1" :max="1000"></a-input-number> 次
        <MinusCircleOutlined @click="del(index)" class="m-l-5" />
      </p>
      <a-button @click="addNumber">添加</a-button>
    </a-form-item>
    <a-form-item :wrapper-col="{offset:10}">
  <a-button @click="submit"  type="primary">确定</a-button>
    </a-form-item>
  </a-form>
</template>

<script>
import { MinusCircleOutlined,InfoCircleOutlined } from "@ant-design/icons-vue";
import { ref } from "vue";
import { message } from "ant-design-vue";
const rules = {
  num_arr: [{ required: true, message: "请选中客户标签" }],
  rule_mark_num: [{ required: true, message: "请选择星期" }],
};
export default {
  components: { MinusCircleOutlined,InfoCircleOutlined },
  setup(props, { emit }) {
    const ruleForm = ref();
    const form = ref({ num_arr: [{number:null}], rule_mark_num:'1' });
    const submit = () => {
      ruleForm.value
        .validate()
        .then(async (res) => {
          var length = form.value.num_arr.filter((v) => v.number).length;
          if (length != form.value.num_arr.length) {
            message.error("请输入完整次数");
            return;
          }
          emit("ployDone", {
            rule_mark_num: '1',
            index:form.value.index,
            num_arr: form.value.num_arr.map((v) => v.number),
          });
        })
        .catch((error) => error);
    };
    const del = (index) => {
      form.value.num_arr.splice(index, 1);
    };
    const addNumber = () => {
      form.value.num_arr.push({ number: "" });
    };
    const inputNumber = (e) => {
      console.log(e);
    };
     const renderDetail=(data,index)=>{
          form.value={rule_mark_num:'1',index},
          form.value.num_arr=[]
          data.num_arr.forEach(element => {
              form.value.num_arr.push({
                number:element
              })
          });
          console.log(form.value)
      }
    return {
      form,
      ruleForm,
      rules,
      addNumber,
      submit,
      inputNumber,
      del,
      renderDetail
    };
  },
};
</script>